<app-tab-layout [loading]="loading()" [error]="error">
  @if (initialized()) {
    <app-api-table
      [name]="name"
      [endpoint]="'/visits/tables/countries'"
      [chartColumn]="'Country'"
    >
    </app-api-table>
  }
</app-tab-layout>
